module.exports = __webpack_public_path__ + "static/media/Misiones.28e3cea2.svg";